import { render, staticRenderFns } from "./TemplateCrud.vue?vue&type=template&id=9cbb7812"
import script from "./TemplateCrud.vue?vue&type=script&lang=js"
export * from "./TemplateCrud.vue?vue&type=script&lang=js"
import style0 from "./TemplateCrud.vue?vue&type=style&index=0&id=9cbb7812&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports